import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "product", "empty", "count", "checkbox"]

  connect() {
    this.filter()
    this.updateCount()
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    let visible = 0

    this.productTargets.forEach((row) => {
      const matches = row.dataset.searchText.includes(query)
      row.hidden = !matches
      row.style.display = matches ? "" : "none"
      if (matches) visible += 1
    })

    this.emptyTarget.hidden = visible > 0
  }

  updateCount() {
    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    this.countTarget.textContent = `${selected} selected`
  }
}
